import * as Sentry from "@sentry/browser"
import { Button } from "@suraasa/placebo-ui"
import React, { useState } from "react"

const SentryErrorTesting = () => {
  const items = null

  const [mount, setMount] = useState(false)

  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-5">
      <Button color="black" onClick={() => setMount(true)}>
        Mount error
      </Button>
      <Button
        color="black"
        onClick={() => {
          Sentry.captureException("generated error")
        }}
      >
        Error
      </Button>
      {/* @ts-expect-error this is error */}
      {mount && items.length}
    </div>
  )
}

export default SentryErrorTesting
